exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".quickUploadComponent---16vL5 {\n  display: block; }\n\n.uploadedRecordCount---1YNvQ {\n  color: #32a8a7;\n  font-weight: 500; }\n\n.message---1jGTT {\n  display: inline;\n  padding-left: 25px;\n  line-height: 27px; }\n\n.rowNumber---271ON {\n  font-size: 14px; }\n\n.resultContainer---30PJ6 {\n  color: #000;\n  font-family: Poppins;\n  font-size: 14px;\n  line-height: 27px; }\n\n.resultSection---4KJZ- {\n  margin: 10px 0.1px; }\n\n@media print {\n  .resultContainer---30PJ6 {\n    width: 100%; } }\n", ""]);

// exports
exports.locals = {
	"quickUploadComponent": "quickUploadComponent---16vL5",
	"uploadedRecordCount": "uploadedRecordCount---1YNvQ",
	"message": "message---1jGTT",
	"rowNumber": "rowNumber---271ON",
	"resultContainer": "resultContainer---30PJ6",
	"resultSection": "resultSection---4KJZ-"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/containers/quick-upload/index.scss
// module id = 1185
// module chunks = 3